export const API_PATH_ApiAlertMgtmAlertHandlingSearchGet = '/services/alerts-mgtm/apiAlertMgtmAlertHandlingSearchGet';
